// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_LegalClientController_GetList_OnboardingStatuses_Items as LegalClientOnboardingStatusTypeApi,
  Query_LegalClientController_GetList_AllOf_1_List_Items_OnboardingStatus as LegalClientOnboardingStatusTypeApi2,
  Query_LegalClientController_GetAvailableStatuses_Onboarding_Items as LegalClientOnboardingStatusTypeApi3,
  Query_LegalClientController_GetById_OnboardingStatus as LegalClientOnboardingStatusTypeApi4,
  Query_LegalClientController_GetById_Onboarding_Statuses_Items_Value as LegalClientOnboardingStatusTypeApi5,
  Query_LegalClientController_GetList_AllOf_1_List_Items_Onboarding_Statuses_Items_Value as LegalClientOnboardingStatusTypeApi6,
} from 'api/generated/graphql';
import {
  OnboardingStatusType,
  LegalClientOnboardingStatusType,
} from 'api/types/entity';
import { Maybe } from 'types/maybe';

type Status =
  | LegalClientOnboardingStatusTypeApi
  | LegalClientOnboardingStatusTypeApi2
  | LegalClientOnboardingStatusTypeApi3
  | LegalClientOnboardingStatusTypeApi4
  | LegalClientOnboardingStatusTypeApi5
  | LegalClientOnboardingStatusTypeApi6;

const statusMap: Record<Status, LegalClientOnboardingStatusType> = {
  [LegalClientOnboardingStatusTypeApi.FillingOut]:
    OnboardingStatusType.FillingOut,
  [LegalClientOnboardingStatusTypeApi.AccountOpened]:
    OnboardingStatusType.AccountOpened,
  [LegalClientOnboardingStatusTypeApi.ComplianceCheck]:
    OnboardingStatusType.ComplianceCheck,
  [LegalClientOnboardingStatusTypeApi.AccountOpeningDenied]:
    OnboardingStatusType.AccountOpeningDenied,
  [LegalClientOnboardingStatusTypeApi.AmlCftCheck]:
    OnboardingStatusType.AmlCftCheck,
  [LegalClientOnboardingStatusTypeApi.AccountOpening]:
    OnboardingStatusType.AccountOpening,
  [LegalClientOnboardingStatusTypeApi.AwaitingAccountOpening]:
    OnboardingStatusType.AwaitingAccountOpening,
  [LegalClientOnboardingStatusTypeApi.AwaitingAmlCftCheck]:
    OnboardingStatusType.AwaitingAmlCftCheck,
  [LegalClientOnboardingStatusTypeApi.AwaitingComplianceCheck]:
    OnboardingStatusType.AwaitingComplianceCheck,
  [LegalClientOnboardingStatusTypeApi.AwaitingValidation]:
    OnboardingStatusType.AwaitingValidation,
  [LegalClientOnboardingStatusTypeApi.BoardReview]:
    OnboardingStatusType.BoardReview,
  [LegalClientOnboardingStatusTypeApi.ValidationCheck]:
    OnboardingStatusType.ValidationCheck,
  [LegalClientOnboardingStatusTypeApi.PendingBoardReview]:
    OnboardingStatusType.PendingBoardReview,
  [LegalClientOnboardingStatusTypeApi.SigningDocuments]:
    OnboardingStatusType.SigningDocuments,
  [LegalClientOnboardingStatusTypeApi.AwaitingPaymentConfirmation]:
    OnboardingStatusType.AwaitingPaymentConfirmation,
  [LegalClientOnboardingStatusTypeApi.SigningQuestionnaire]:
    OnboardingStatusType.SigningQuestionnaire,
};

export const parseLegalClientOnboardingStatus = (
  status: Maybe<Status>
): LegalClientOnboardingStatusType =>
  status ? statusMap[status] : OnboardingStatusType.FillingOut;
